import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  selectedInspectorId: "",
  referenceNo: "",
  activeStep: 0,
  formData: {
    manualRef: "",
    verificationType: "",
    date: "",
    description: "",
    testInstrument: "",
    clientName: "",
    installationAddress: "",
    location: "",
    circuitTested: "",
    nextInspectionAfter: "",
    handoverComment: "",
    pvStringComment: "",
    power: "",
    estimatedPerformance: "",
  },
};

const InspectionInfoSlice = createSlice({
  name: "InspectionInfo",
  initialState,
  reducers: {
    setInspectorId: (state, action) => {
      state.selectedInspectorId = action.payload; // only ID
    },

    updateStep: (state, action) => {
      state.activeStep = action.payload;
    },

    updateFormField: (state, action) => {
      const { field, value } = action.payload;
      state.formData[field] = value;
    },

    setReferenceNo: (state, action) => {
      state.referenceNo = action.payload;
    },

    setInspectionIntial: (state, action) => {
      const { formData, selectedInspectorId, referenceNo } = action.payload;

      if (formData) {
        state.formData = { ...state.formData, ...formData };
      }

      if (selectedInspectorId) {
        state.selectedInspectorId = selectedInspectorId;
      }

      if (referenceNo) {
        state.referenceNo = referenceNo;
      }
    },

    resetInspectionState: (state) => {
      state.selectedInspectorId = "";
      state.referenceNo = "";
      state.activeStep = 0;
      state.formData = { ...initialState.formData };
    },
  },
});

export const {
  setInspectorId,
  updateStep,
  updateFormField,
  setReferenceNo,
  setInspectionIntial,
  resetInspectionState,
} = InspectionInfoSlice.actions;

export default InspectionInfoSlice.reducer;
